<gb-presenter-edit>
  <div gbPresenterElementsSidebarHeader class="template-sidebar-header-container">
    <gb-presenter-template-config
      #templateConfig
      [template]="selectedTemplate$ | async"
      [displayPermissions]="false"
    ></gb-presenter-template-config>
  </div>

  <div gbPresenterBottomToolbar></div>
  <div gbPresenterConfigSidebarHeader>
    <button mat-flat-button translate="SAVE" class="save-template-button" (click)="saveTemplate()"></button>
  </div>
</gb-presenter-edit>
